import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ember-works/artifacts/k9fkrnu6_59301B32-BC08-4447-ACD0-F10D5195B21A.png";

// Official Emberline Fabrication logo.
// variant: "nav" (compact horizontal-ish), "hero" (large), "mark" (icon size), "footer"
export default function EmberlineLogo({ className = "", variant = "nav" }) {
  if (variant === "mark") {
    return (
      <img
        src={LOGO_URL}
        alt="Emberline Fabrication"
        className={`object-contain ${className}`}
        data-testid="emberline-logo-mark"
      />
    );
  }

  if (variant === "hero") {
    return (
      <img
        src={LOGO_URL}
        alt="Emberline Fabrication"
        className={`object-contain ${className}`}
        data-testid="emberline-logo-hero"
      />
    );
  }

  if (variant === "footer") {
    return (
      <img
        src={LOGO_URL}
        alt="Emberline Fabrication"
        className={`object-contain ${className}`}
        data-testid="emberline-logo-footer"
      />
    );
  }

  // Default nav variant
  return (
    <img
      src={LOGO_URL}
      alt="Emberline Fabrication"
      className={`object-contain h-12 w-auto md:h-14 ${className}`}
      data-testid="emberline-logo"
    />
  );
}
